// extracted by mini-css-extract-plugin
export default {"base":"Email_base__oPuUF","root":"Email_root__9SKTo","content":"Email_content__1nGKw","header":"Email_header__fUHO6","form":"Email_form__UE-YT"};